<div class="card p-4">
  <!-- Tax Form -->
  <form #taxForm="ngForm">
    <div class="row g-3 mb-3">
      <!-- Tax Name -->
      <div class="col-md-11 mt-2">
        <label for="taxName" class="form-label">{{ 'TAX_NAME_LABEL' | translate }}</label>
        <input
          type="text"
          id="taxName"
          [(ngModel)]="editModel.name"
          name="taxName"
          class="form-control"
          required
          placeholder="e.g. Sales Tax"
        />
      </div>
    </div>

    <div class="row g-3">
      <div class="col-md-4">
        <label class="form-label">{{ 'TAX_RATE_PERCENT_LABEL' | translate }}</label>
      </div>
      <div class="col-md-6">
        <label class="form-label">{{ 'VALID_FROM_LABEL' | translate }}</label>
      </div>
    </div>
    <!-- Editable Rates -->
    <div *ngFor="let rate of editModel.rates; let i = index" class="row g-3 mb-2">
      <div class="col-md-4">
        <input
          type="number"
          id="taxRate"
          [ngModel]="rate.rate | number"
          (ngModelChange)="rate.rate = $event"
          name="taxRate-{{ i }}"
          class="form-control"
          required
          placeholder="e.g. 15"
        />
      </div>

      <div class="col-md-7">
        <input
          type="date"
          id="validFrom-{{ i }}"
          [ngModel]="rate.validFrom | date: 'yyyy-MM-dd'"
          (ngModelChange)="rate.validFrom = $event"
          name="validFrom-{{ i }}"
          class="form-control"
          required
        />
      </div>

      <div class="col-md-1 ms-auto d-flex align-items-end">
        <lh-dashboard-taxes-card-delete-button (buttonClick)="removeRate(i)" />
      </div>
    </div>

    <!-- Add New Rate Button -->
    <div class="d-flex align-items-end">
      <button type="button" class="btn btn-link mb-1 ps-0 ms-0" (click)="addRate()">
        {{ 'ADD_TAX_RATE' | translate }}
      </button>
    </div>

    <!-- Save Button -->
    <div class="d-flex mt-2 justify-content-end gap-4">
      <button
        type="button"
        class="btn bnt-sm btn-outline-danger delete-tax-button"
        (click)="onDeleteClick()"
        [disabled]="isLoading()"
      >
        <span *ngIf="isDraft">{{ 'CANCEL' | translate }}</span>
        <span *ngIf="!isDraft">{{ 'DELETE' | translate }}</span>
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="!taxForm.valid || isLoading()" (click)="onSave()">
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </form>
</div>
